.wave {
  flex: 1;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 3px;
  overflow: hidden;
}

.bar {
  /* No min-width: bars flex to fill the container so the waveform never overflows a narrow chat
     panel (which would clip the right-hand / played region under the wrapper's overflow: hidden). */
  flex: 1;
  border-radius: 2px;
}
